module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kh-Lc.a3862e3f.png";